"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const domain_1 = require("@home-health-notify/domain");
const uiSchema_1 = require("../../common/appointment/uiSchema");
const uiSchema = {
    type: "VerticalLayout",
    elements: [
        {
            type: domain_1.RenderersUIType.AppointmentPicker,
            label: "SOC Visit",
            scope: "#/properties/socDate",
            options: {
                disableFuture: true,
            },
        },
        {
            type: "HorizontalLayout",
            elements: [
                { type: "Control", scope: "#/properties/doctorName" },
                {
                    type: "HorizontalLayout",
                    scope: "#/properties/phoneNumberWithCountryCode",
                    elements: [
                        {
                            type: "Control",
                            scope: "#/properties/phoneNumberWithCountryCode/properties/countryCode",
                            label: "Code",
                        },
                        {
                            type: "Control",
                            scope: "#/properties/phoneNumberWithCountryCode/properties/phoneNumber",
                            label: "Phone Number",
                        },
                    ],
                },
            ],
        },
        {
            type: "HorizontalLayout",
            elements: [
                { type: "Control", scope: "#/properties/contactPerson" },
                {
                    type: "Control",
                    scope: "#/properties/nextDoctorVisit",
                    options: {
                        disablePast: true,
                    },
                },
            ],
        },
        (0, uiSchema_1.makeAppointmentUiSchema)("clinicianAppointment", "Next Clinician Visit", {
            disablePast: true,
        }),
        (0, uiSchema_1.makeAppointmentConflictsUiSchema)("clinicianAppointment"),
        { type: "Control", scope: "#/properties/notes" },
    ],
};
exports.default = uiSchema;
